(function () {

    'use strict';
    angular.module('angulartics.etracker', [
        'angulartics'
    ])
    .config(config);

    config.$inject = [
        '$analyticsProvider',
        '$windowProvider',
        '$injectorProvider'
    ];

    function config($analyticsProvider, $windowProvider, $injectorProvider) {
        var $window = $windowProvider.$get(),
            $injector = $injectorProvider.$get(),
            $timeout = $injector.get('$timeout'),
            angulartics = $window.angulartics;

        $analyticsProvider.settings.pageTracking.trackRelativePath = true;
        $analyticsProvider.settings.etracker = {
            initialPageLoad: true,
            trackingEnabled: false,
            accountId: null,
            pageTrackPrefix: '',
            eventTrackPrefix: '',
            eventTrackDefaultTags: ''
        };
        function getPagename(path) {
            return ([($analyticsProvider.settings.etracker.pageTrackPrefix || ''), path].join('')).replace(/\/$/, '');
        }
        $analyticsProvider.registerSetUsername(function (accountId) {
            $analyticsProvider.settings.etracker.accountId = accountId;
        });

        angulartics.waitForVendorApi('_etracker', 500, function (_etracker) {
            $analyticsProvider.registerSetUserProperties(function (properties) {
                properties = properties || {};

                try {
                    if (!_etracker) {
                        return;
                    }

                    var trackingEnableDisableFn = _etracker[$analyticsProvider.settings.etracker.trackingEnabled ? 'enableTracking' : 'disableTracking'];
                    if (angular.isFunction(trackingEnableDisableFn)) {
                        _etracker[$analyticsProvider.settings.etracker.trackingEnabled ? 'enableTracking' : 'disableTracking']();
                    }

                    angular.forEach(properties.etracker, function (value, prop) {
                        $analyticsProvider.settings.etracker[prop] = value;

                        if (prop === 'trackingEnabled') {
                            trackingEnableDisableFn = _etracker[value ? 'enableTracking' : 'disableTracking'];
                            if (angular.isFunction(trackingEnableDisableFn)) {
                                _etracker[value ? 'enableTracking' : 'disableTracking']();
                            }
                        }
                    });
                } catch (e) {
                }
            });
            $analyticsProvider.registerPageTrack(function () {
                var pagename = '',
                    areas = '',
                    locationHtml5Url = arguments[1],
                    url = arguments[0] || '',
                    path = locationHtml5Url ? locationHtml5Url.$$path : arguments[0];

                if ($window.et_eC_Wrapper && path && $analyticsProvider.settings.etracker.trackingEnabled) {
                    try {
                        pagename = getPagename(path);
                        areas = $analyticsProvider.settings.etracker.areas;
                        if ($analyticsProvider.settings.etracker.initialPageLoad && (pagename.indexOf(getPagename($analyticsProvider.settings.etracker.startpage)) > -1 || url.indexOf(getPagename($analyticsProvider.settings.etracker.startpage)) > -1)) {
                            $analyticsProvider.settings.etracker.initialPageLoad = false;
                            return;
                        }

                        $analyticsProvider.settings.etracker.initialPageLoad = false;

                        $window.et_eC_Wrapper($analyticsProvider.settings.etracker.accountId, pagename, areas);
                    } catch (e) {
                    }
                }
            });
            $analyticsProvider.registerEventTrack(function (action, properties) {
                $timeout(function () {
                    properties = properties || {};

                    var pagename = '',
                        areas = '',
                        tags = '',
                        target = '',
                        trackingProvider = angular.isArray(properties.trackingProvider) ? properties.trackingProvider : [properties.trackingProvider];

                    if ($window.ET_Event && action && properties.target && trackingProvider.indexOf('etracker') > -1 && $analyticsProvider.settings.etracker.trackingEnabled) {
                        try {
                            if (action === 'sale' || action === 'lead' && $window.et_eC_Wrapper) {
                                pagename = getPagename(properties.path);
                                areas = $analyticsProvider.settings.etracker.areas;
                                $window.et_eC_Wrapper($analyticsProvider.settings.etracker.accountId, pagename, areas, null, null, properties.target, properties.val, null, properties.sale);
                            } else {
                                properties.tags = properties.tags || '';

                                tags = [$analyticsProvider.settings.etracker.eventTrackDefaultTags, properties.tags].join(',');
                                target = [($analyticsProvider.settings.etracker.eventTrackPrefix || ''), properties.target].join('');

                                if (angular.isFunction($window.ET_Event[action])) {
                                    $window.ET_Event[action](target, tags);
                                } else {
                                    $window.ET_Event.eventStart(properties.category, target, action, tags);
                                }
                            }
                        } catch (error) {
                        }
                    }
                });
            });
        });
    }
})();
